import Component_ToggleScene_d9984d7dbc9adc167938b273a62251d4 from "../../../../content/examples/basic/toggle-scene/ToggleScene";
import Devtool_ToggleScene_d9984d7dbc9adc167938b273a62251d4 from "!!@devtool/loader!../../../../content/examples/basic/toggle-scene/ToggleScene";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_ToggleScene_d9984d7dbc9adc167938b273a62251d4,
  Devtool_ToggleScene_d9984d7dbc9adc167938b273a62251d4,
  DevTool,
  React
};